import React, { useContext } from 'react';
import { DashboardPopUpContext } from '../../../dashboard-components/context/DashboardPopUpContext';
import PrefixModal from './PrefixModal';

const PrefixClickable = ({ prefix }) => {

  const { showPopUp } = useContext(DashboardPopUpContext);

  const showPopUpModal = () => {
    if (!prefix.Compromised) return;

    showPopUp(<PrefixModal prefix={prefix} />);
  }

  const style = {
    color: prefix.Compromised == true ? 'red' : 'black',
    fontWeight: prefix.Compromised == true ? 'bold' : 'normal',
    cursor: prefix.Compromised == true ? 'pointer' : 'auto',
  };

  return (
    <td onClick={showPopUpModal} style={style}>{prefix.Prefix}</td>
  );
};

export default PrefixClickable;